import Api from "@/components/Api";

import trees from '../../assets/svg/trees.svg'
import "./style.css";

export default class NewsAndEvents {
  static selector = ".news-and-events";

  constructor(block) {
    this.block = block;

    this.featured = this.block.querySelector(".featured");
    this.list = this.block.querySelector(".news-and-events__list");
    this.showMoreButton = this.block.querySelector(
      ".news-and-events__show-more"
    );
    this.maxCount = parseInt(this.block.dataset.count, 10);
    this.pageSize = this.list.childElementCount;
  }

  appendArticles = (articles) => {
    articles.forEach((articleData) => {
      const anchorElement = document.createElement("a");
      anchorElement.classList.add("col", "col-sm-6", "col-md-4", "col-lg-3");
      anchorElement.setAttribute("href", articleData.url);
      anchorElement.setAttribute("rel", "noopener noreferrer");

      const articleElement = document.createElement("div");
      articleElement.classList.add("article-item", "article-item--loading");

      if (articleData.image) {
        const imageElement = document.createElement("div");
        imageElement.classList.add("article-item__image");
        imageElement.innerHTML = `
          <div class="label label--${articleData.type}">
            <p>${articleData.type === "event" ? "Event" : "News"}</p>
          </div>
          <img alt="${articleData.imageAlt}" src="${articleData.image}"/>
        `;

        articleElement.appendChild(imageElement);
      } else {
        const imageElement = document.createElement("div");
        imageElement.classList.add("article-item__image-box");

        imageElement.innerHTML = `
          <div class="label label--${articleData.type}">
            <p>${articleData.type === "event" ? "Event" : "News"}</p>
          </div>
          <div class="img-placeholder">
            <img src="${trees}" />  
          </div>
        `;

        articleElement.appendChild(imageElement);
      }

      articleElement.innerHTML =
        articleElement.innerHTML +
        `
        <p class="note">${articleData.date}</p>
        <h5>${articleData.title}</h5>
      `;

      anchorElement.appendChild(articleElement);

      this.list.appendChild(anchorElement);

      // fade in
      setTimeout(() => {
        articleElement.classList.remove("article-item--loading");
      }, 500 * Math.random());
    });

    this.count = this.list.childElementCount;

    if (this.count >= this.maxCount) {
      this.showMoreButton.classList.add("news-and-events__show-more--done");
    }
  };

  handleShowMoreClick = async () => {
    this.showMoreButton.classList.add("news-and-events__show-more--loading");
    this.showMoreButton.disabled = true;

    try {
      const newsAndEvents = await Api.getNewsAndEvents({
        page: this.page + 1,
        size: this.pageSize,
        exclude: this.featured ? [this.featured.dataset.id] : [],
      });

      this.appendArticles(newsAndEvents);

      this.page += 1;
    } catch (error) {
      console.error("Error loading new posts", error);
    }

    this.showMoreButton.disabled = false;
    this.showMoreButton.classList.remove("news-and-events__show-more--loading");
  };

  onReady = () => {
    this.page = 1;
    this.count = this.list.childElementCount;

    if (this.showMoreButton) {
      this.showMoreButton.addEventListener("click", this.handleShowMoreClick);

      if (this.count >= this.maxCount) {
        this.showMoreButton.classList.add("news-and-events__show-more--done");
      }
    }
  };
  onDestroy = () => {
    if (this.showMoreButton) {
      this.showMoreButton.removeEventListener(
        "click",
        this.handleShowMoreClick
      );
    }
  };
}
